










import NextQuerySuggestion from '@empathybroker/ebx-gluon/dist/components/pure/suggestions/next-query-suggestion.vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlNextQuerySuggestion extends NextQuerySuggestion {}
